import { Injectable } from '@angular/core';
import { map, finalize } from 'rxjs/operators';
import { AngularFireStorage } from '@angular/fire/storage';
import { Observable, of } from 'rxjs';
import * as _ from 'lodash';

import { DataService } from './data.service';
import { CategoryItem, CategoryResults } from '../interfaces/category.model';
import { LoadingService } from './loading.service';

@Injectable({
  providedIn: 'root'
})
export class CategoriesService {
  private categoryData: CategoryResults;
  private unknownImageUrl: string;

  constructor(
    private fireStorage: AngularFireStorage,
    private dataSvc: DataService,
    private loadingSvc: LoadingService
  ) { }

  getCategories(): Observable<CategoryResults> {
    if (this.categoryData) {
      return of(this.categoryData);
    }

    this.loadingSvc.show();
    return this.dataSvc.getCategories().pipe(
      map(data => this.processCategories(data)),
      map(data => {
        data.items = _.orderBy(data.items, (item) => item.trend, ['desc']);
        data.items.forEach(async item => item.imageUrl = await this.processImage(item.image));
        this.categoryData = data;
        return data;
      }),
      finalize(() => this.loadingSvc.hide())
    );
  }

  // ================================================
  private processCategories(data: any[]): CategoryResults {
    const categories = _.uniq(_.map(data, (item) => item.division)).sort();
    let items: CategoryItem[] = [];
    categories.forEach(cat => {
      items = items.concat(this.processCategoryItems(data, cat));
    });

    return { categories, items };
  }

  // ================================================
  private processCategoryItems(data: any[], category: string) {
    const items = data.filter(item => item.division === category);
    const catItems: CategoryItem[] = [];

    for (const item of items) {
      const imageName = item.category.toLowerCase().replace(/ & /g, '_').replace(/ /g, '_') + '.jpg';
      catItems.push({
        name: item.category,
        division: category,
        image: imageName,
        trend: this.setTrend(item.category),
      });
    }

    return catItems;
  }


  // ================================================
  private setTrend(name: string): number {
    return Math.floor(Math.random() * 250) - 20;
  }

  // ================================================
  private async processImage(name: string) {
    try {
      const ref = this.fireStorage.storage.ref(`images/${name}`);
      return await ref.getDownloadURL();
    } catch (err) {
      if (!this.unknownImageUrl) {
        const ref = this.fireStorage.storage.ref('images/unknown.jpg');
        this.unknownImageUrl = await ref.getDownloadURL();
      }
      return this.unknownImageUrl;
    }
  }

}
